<form *transloco="let t; read: 'mailReply'" (submit)="onSubmit()">
  <crm-container color="primary">
    <crm-form-field-universal [parentFormGroup]="form" [field]="fieldsMap.subject"></crm-form-field-universal>
    <crm-form-field-textarea
      [parentFormGroup]="form"
      [field]="fieldsMap.body"
      [minRows]="5"
      [maxRows]="20"
    ></crm-form-field-textarea>

    <crm-actions-row>
      <button mat-flat-button type="submit" color="primary" [disabled]="form.invalid">{{ t('send') }}</button>
      <button mat-flat-button type="reset" (click)="onCancel()">{{ t('cancel') }}</button>
    </crm-actions-row>
  </crm-container>
</form>
